export enum AVAILABILITY_MODE {
  DAILY = 'DAILY',
  TIMESLOT = 'TIMESLOT',
}

export type AvailabilityMode =
  (typeof AVAILABILITY_MODE)[keyof typeof AVAILABILITY_MODE];
